module.exports = __webpack_public_path__ + "img/santafe.b58e8df3.jpg";